var styles = ["img[_ngcontent-%COMP%]{width:100%;height:100%;max-width:350px}@media (max-width:991.98px){img[_ngcontent-%COMP%]{max-width:300px}}@media (max-width:767.98px){img[_ngcontent-%COMP%]{max-width:250px}}"];
export { styles as styles };
